import { render } from "./PwaNotification.vue?vue&type=template&id=4a54e990&scoped=true"
import script from "./PwaNotification.vue?vue&type=script&lang=js"
export * from "./PwaNotification.vue?vue&type=script&lang=js"

import "./PwaNotification.vue?vue&type=style&index=0&id=4a54e990&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a54e990"]])

export default __exports__